import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { useTranslation } from 'react-i18next';
import { usePackageContext } from '../../../../utils/context/PackageContext';
import { UsedByBrandFloors } from './UsedByBrandFloors';
import { UsedByDeals } from './UsedByDeals';

type UsedBySectionProps = {
  isCurated?: boolean;
};

export const UsedBySection = ({ isCurated = false }: UsedBySectionProps) => {
  const { t } = useTranslation();
  const { useDetailsConfig, isOaSuborg } = usePackageContext();
  const detailsConfig = useDetailsConfig();

  if (isCurated && isOaSuborg) return null;

  return (
    <FormSection divider title={t('Used By')}>
      {detailsConfig.usedByBrandFloorsVisible && <UsedByBrandFloors />}
      <UsedByDeals />
    </FormSection>
  );
};
